import { Button, Input } from '@root/components'
import {
  IVerohallintoCertificateTransmissionValues,
  addVerohallintoCertificate
} from '@root/query/integrations/verohallinto'
import { get, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useBusinessContext } from '@root/context'

const VerohallintoSettingsForm: React.FC = () => {
  const { slug } = useBusinessContext()
  const queryClient = useQueryClient()

  const [t] = useTranslation()

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<IVerohallintoCertificateTransmissionValues>()

  const startMutation = useMutation({
    mutationFn: (data: IVerohallintoCertificateTransmissionValues) =>
      addVerohallintoCertificate({ slug: slug }, data),
    ...{
      onSuccess: () => {
        reset()
        queryClient.invalidateQueries({ queryKey: [slug, 'verohallinto_certificate_status'] })
        toast.success(t('settings.verohallintoSettings.form.success'))
      }
    }
  })

  const onSubmit = (data: IVerohallintoCertificateTransmissionValues) => {
    startMutation.mutate(data)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input
        label={t('settings.verohallintoSettings.form.identifier.label')}
        info={t('settings.verohallintoSettings.form.identifier.info')}
        name="transmission_id"
        {...register('transmission_id', {
          required: { value: true, message: t('validation.required') }
        })}
        required
        errors={get(errors, 'transmission_id')}
      />

      <Input
        label={t('settings.verohallintoSettings.form.password.label')}
        info={t('settings.verohallintoSettings.form.password.info')}
        name="transmission_password"
        {...register('transmission_password', {
          required: { value: true, message: t('validation.required') }
        })}
        required
        errors={get(errors, 'transmission_password')}
      />

      <Button
        type="submit"
        intent="success"
        style={{ marginLeft: 'auto' }}
        disabled={startMutation.isPending}
        showSpinner={startMutation.isPending}
      >
        {t('settings.verohallintoSettings.form.send')}
      </Button>
    </form>
  )
}

export default VerohallintoSettingsForm
